import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginRequest, LoginResponse, Readiness } from 'svnxii-modules/auth/models';
import { EnvironmentService } from 'svnxii-ng-shared/services';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly environment = inject(EnvironmentService);
  private http = inject(HttpClient);
  private readonly API_URL = this.environment.apiUrl;

  login(credentials: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${this.API_URL}/api/v1/iam/auth/login`,
      credentials,
    );
  }

  checkReadiness() {
    return this.http.get<Readiness>(
      `${this.API_URL}/api/v1/organization/initialization/readiness`,
    );
  }
}
